export default "__VITE_ASSET__DqwAGx4k__"